// 这里存放项目所需要的各种常量，通常也包括各种配置项
export default {
  PLATFORM_NAME: 'Cyber Security 网络安全',
  MAX_ALIVE_COMPONENTS: 8,
  MAX_NAV_LIST: 8,
  // 是否启用前端菜单权限
  ENABLE_FE_PERMISSION: true,
  // 是否在顶部显示（缓存）流量历史
  SHOW_TOP_NAV_HISTORY: false,
  // 是否默认收起侧边栏（展开页面内容）
  EXPAND_CONTENT_DEFAULT: false
}

// 车型状态（0-可用 1-不可用）
export const VEHICLE_MODEL_STATUS = {
  available: 0,
  unavailable: 1
}
